<template>
    <div class="availability-calendar">
        <div class="availability-calendar__header">
            <div class="date-switch">
                <button class="switch-button switch-left" :class="{disabled: disableCalendarBackButton }" @click.navite="date = date.clone().subtract(1, 'week')">
                    <span class="material-icons-round">chevron_left</span>
                </button>
                <button class="switch-button switch-right" @click="date = date.clone().add(1, 'week')">
                    <span class="material-icons-round">chevron_right</span>
                </button>
                <span class="switch-text">{{ dateFormatted }}</span>

                <VButton :label="__('Today')" variant="secondary" size="xs" @onClick="date = moment()" />
            </div>

            <!-- <DateSwitch v-model="date" /> -->

            <ul class="helper-legend">
                <li class="legend-slot green">
                    <span>{{ __('Consultation') }}</span>
                </li>
                <!-- <li class="legend-slot grey">
                    <span>{{ __('Příprava na konzultaci') }}</span>
                </li> -->
                <li class="legend-slot lightgreen">
                    <span>{{ __('Default / increased availability') }}</span>
                </li>
            </ul>
        </div>

        <section class="availability-calendar__section">
            <aside class="availability-calendar__hours">
                <span v-for="hour in 15" class="availability-calendar__hour">
                    {{ formatHour(6 + hour) }}
                </span>
            </aside>

            <div class="availability-calendar__days">
                <div
                    v-for="date in dates"
                    :class="{ 'availability-calendar__day--today': date.isSame(moment(), 'day') }"
                    class="availability-calendar__day"
                >
                    <div class="availability-calendar__day-header">
                        <strong class="availability-calendar__day-name">{{ date | dayName | capitalize }}</strong>
                        <span class="availability-calendar__day-date">
                            {{ date.format('D. MMMM') }}
                        </span>
                    </div>

                    <div class="availability-calendar__day-slots">
                        <div
                            v-for="slots in getOpeningHours(date)"
                            :style="`height: ${slots.length * 5}px; top: ${computeGap(slots)}px;`"
                            class="record record--opening_hours"
                        ></div>

                        <div
                            v-for="slots in getVacations(date)"
                            :style="`height: ${slots.length * 5}px; top: ${computeGap(slots)}px;`"
                            class="record record--vacations"
                        >
                            <span>{{ __('Holiday') }}</span>
                        </div>

                        <template
                            v-for="({ pause_slots, slots_without_pause, name, surname, phone, time, consultation_type }, index) in getConsultations(
                                date
                            )"
                        >
                            <!-- <div
                                :style="`height: ${pause_slots.length * 5}px; top: ${computeGap(pause_slots)}px;`"
                                class="record record--consultations-pause_slots"
                            ></div> -->

                            <div
                                :style="`height: ${slots_without_pause.length * 5 + 5}px; top: ${computeGap(
                                    slots_without_pause
                                )}px;`"
                                class="record record--consultations-slots_without_pause tooltip"
                            >
                                <div @click="showInfo(date + '-' + index)">
                                    <span :title="surname+', '+time">{{ surname }}, {{ time }}</span>
                                </div>
                                <div
                                    :id="'record-info-' + date + '-' + index"
                                    :class="['tooltip-content record--consultations-info', {'tooltip-right': tooltipRightPosition(date)}]"
                                >
                                    <header>
                                        <span>{{ getConsultationTypeTitle(consultation_type) }}</span>
                                        <button type="button" @click="close">
                                            <svg-icon icon="close-modal"></svg-icon>
                                        </button>
                                    </header>
                                    <div>
                                        <div>
                                            <strong>{{ __('Patient') }}:</strong>
                                            <span>{{ name }} {{ surname }}</span>
                                        </div>
                                        <div>
                                            <strong>{{ __('Time') }}:</strong>
                                            <span>{{ time }}</span>
                                        </div>
                                        <div>
                                            <consultation-call :coach_name="coach.daktela_name" :cloudtalk_id="coach.cloudtalk_id" :phone_number="getFormattedPhoneNumber(phone)" position="calendar"></consultation-call>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SlotsParser from '@/core/SlotsParser'

export default {
    props: {
        coach: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            date: moment(),
            data: {},
            patients: {},
            show: false
        }
    },
    computed: {
        dateFormatted() {
            return `${this.date.startOf('week').format('D. MMMM YYYY')} - ${moment(this.date)
                .endOf('week')
                .format('D. MMMM YYYY')}`
        },
        formattedDateRange() {
            return [this.startDate, this.endDate].map((d) => d.format('YYYY-MM-DD'))
        },
        dates() {
            return _.times(7, (i) => this.startDate.clone().add(i, 'days'))
        },
        startDate() {
            return this.date.clone().startOf('week')
        },
        endDate() {
            return this.date.clone().endOf('week')
        },
        disableCalendarBackButton() {
            return moment(this.coach.created_at).startOf('week').format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD')
        },
        calendarData() {
            const data = this.data[this.formattedDateRange]

            if (!data) {
                return []
            }

            return data
        }
    },
    watch: {
        date() {
            this.fetch()
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        async fetch() {
            if (this.data[this.formattedDateRange]) {
                return
            }

            await this.fetchPatients()

            await this.fetchData()
        },
        async fetchPatients() {
            const patients = await axios
                .post(`/coaches/${this.coach.id}/consultations/patients`, { date: this.formattedDateRange })
                .thenData()

            this.$set(this.patients, this.formattedDateRange, patients)
        },
        async fetchData() {
            const data = await axios
                .post(`/coaches/${this.coach.id}/calendar`, {
                    date: this.formattedDateRange,
                    sources: [
                        'opening_hours',
                        'holidays:remove',
                        'availability_changes:merge|remove',
                        'consultations:join',
                        'vacations:join',
                    ]
                })
                .thenData()

            const formattedData = data.map((item) => {
                if (item.type === 'opening_hours|availability_new') {
                    item.type = 'opening_hours'
                }

                return item
            })

            this.$set(this.data, this.formattedDateRange, formattedData)
        },
        getOpeningHours(date) {
            const record = _.find(this.calendarData, { type: 'opening_hours', date: date.format('YYYY-MM-DD') })

            if (!record || (this.coach.created_at !== "" && date.format('YYYY-MM-DD') < moment(this.coach.created_at).format('YYYY-MM-DD'))) {
                return []
            }

            return SlotsParser.use().toChunks(record.slots)
        },
        getVacations(date) {
            const record = _.find(this.calendarData, { type: 'vacations', date: date.format('YYYY-MM-DD') })

            if (!record || (this.coach.created_at !== "" && date.format('YYYY-MM-DD') < moment(this.coach.created_at).format('YYYY-MM-DD'))) {
                return []
            }

            return SlotsParser.use().toChunks(record.slots)
        },
        getConsultations(date) {
            const records = _.filter(this.calendarData, { type: 'consultations', date: date.format('YYYY-MM-DD') })

            if (!records.length) {
                return []
            }

            return records.map((record) => {
                const slots_without_pause = _.difference(record.slots, record.pause_slots)

                return {
                    pause_slots: record.pause_slots,
                    slots_without_pause,
                    name: this.findPatientName(record),
                    surname: this.findPatientSurname(record),
                    phone: this.findPatientPhone(record),
                    consultation_type: this.findConsultationType(record),
                    time: SlotsParser.use()
                        .setSlotsMinutes(5)
                        .toTime(slots_without_pause)[0]
                        .map(this.getTime)
                        .join(' - ')
                }
            })
        },
        computeGap(slots) {
            const currentFirstSlot = _.first(slots)

            return (currentFirstSlot - 1) * 5
        },
        findPatientSurname({ patient_id }) {
            return _.get(_.find(this.patients[this.formattedDateRange], { patient_id: patient_id }), 'patient.user.surname')
        },
        findPatientName({ patient_id }) {
            return _.get(_.find(this.patients[this.formattedDateRange], { patient_id: patient_id }), 'patient.user.name')
        },
        findPatientPhone({ patient_id }) {
            return _.get(_.find(this.patients[this.formattedDateRange], { patient_id: patient_id }), 'patient.user.latest_phone_number')
        },
        formatHour(hour) {
            return hour < 10 ? `0${hour}` : hour
        },
        showInfo(index) {
            $('.record--consultations-info').hide()
            $('#record-info-' + index).show()
        },
        close() {
            $('.record--consultations-info').hide()
        },
        getTime(datetime) {
            return moment(datetime).format('H:mm')
        },
        findConsultationType({ patient_id }) {
            return _.get(_.find(this.patients[this.formattedDateRange], { patient_id: patient_id }), 'type')
        },
        tooltipRightPosition(date) {
            if (moment(date).format('d') === '5' || moment(date).format('d') === '6' || moment(date).format('d') === '0') {
                return true
            }
        },
        getFormattedPhoneNumber(phone) {
            if(phone.phone_country === 'CZ') {
                return '+420'+phone.phone
            }
            if(phone.phone_country === 'SK') {
                return '+421'+phone.phone
            }
            if(phone.phone_country === 'DE') {
                return '+49'+phone.phone
            }
        },
        getConsultationTypeTitle(type) {
            if(type === 'entry') {
                return lang.get('Initial consultation')
            }

            if(type === 'adhoc') {
                return lang.get('Ad-hoc consultation')
            }

            if(type === 'review_1') {
                return '1. '+lang.get('Review consultation')
            }

            if(type === 'review_2') {
                return '2. '+lang.get('Review consultation')
            }

            if(type === 'review_3') {
                return '3. '+lang.get('Review consultation')
            }

            if(type === 'review_4') {
                return '4. '+lang.get('Review consultation')
            }

            if(type === 'second') {
                return lang.get('Follow-up consultation')
            }
        }
    }
}
</script>
